import { safeParse, safeStringify } from "@helpers/json-helper";
import { getPathKey } from "../../contexts/CookiesContext";
import { fetchEurUsdRate } from "./get_currency";
import Cookies from "universal-cookie";

const LS_KEY = "eur_usd_rate";
const CACHE_TTL_MS = 60 * 60 * 1000;

/**
 * @description Get the cached EUR/USD rate from localStorage
 * @returns {Promise<{date: string, time: string, rate: number, base: string, quote: string} | null>}
 */

export async function getCachedEurUsdRate() {
  const cached = localStorage.getItem(LS_KEY);
  const pathKey = getPathKey();
  const cookies = new Cookies();
  const publisherId = cookies.get(pathKey)?.publisher_id;
  if (!publisherId || +publisherId === 67) {
    return null;
  }

  const parsed = safeParse(cached);
  const isFresh = Date.now() - parsed?.timestamp < CACHE_TTL_MS;
  if (isFresh) {
    return parsed.rate;
  }
  
  if (cached) {
    try {
      const parsed = safeParse(cached);

      const isFresh = Date.now() - parsed.timestamp < CACHE_TTL_MS;
      if (isFresh) {
        return parsed.rate;
      }
    } catch (e) {
      console.warn("Invalid cached data, ignoring...");
    }
  }

  const result = await fetchEurUsdRate();
  if (result) {
    localStorage.setItem(
      LS_KEY,
      safeStringify({
        rate: result.rate,
        timestamp: Date.now(),
      })
    );
  }
  return result.rate;
}
